export default {
  imageSrc:
    'https://www.nerdwallet.com/cdn/img/homepage/redesign/v3/nw-hp-security-lock.svg',
  securityHeader: 'Your security. Our priority.',
};
